require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
module.exports = require('../modules/$.core').Map;


//////////////////
// WEBPACK FOOTER
// ../~/fbjs/~/core-js/library/es6/map.js
// module id = 704
// module chunks = 17